const SEND_FAILED = 'send failed';
const SENDING = 'sending';
const SENT = 'sent';

export { SEND_FAILED, SENDING, SENT };
